import { Setter } from '@/types/setter';

export enum AggregationType {
  Metrics = 'metrics',
  Sorts = 'sorts',
  Dims = 'dims',
}

export const SORTER_OPTIONS = [
  { label: '不排序', value: null },
  { label: '升序', value: 'ASC' },
  { label: '降序', value: 'DESC' },
];

export const SORTER_SETTERS: Setter[] = [
  {
    title: '排序方式',
    name: AggregationType.Sorts,
    display: 'inline',
    defaultValue: null,
    setter: {
      componentName: 'CnSelectSetter',
      props: {
        options: SORTER_OPTIONS,
      },
    },
  },
];

export const AGGREGATION_METRICS_OPTIONS = [
  {
    label: '不处理',
    value: null,
  },
  {
    label: '求和',
    value: 'SUM',
  },
  {
    label: '最大值',
    value: 'MAX',
  },
  {
    label: '最小值',
    value: 'MIN',
  },
  {
    label: '平均值',
    value: 'AVG',
  },
  {
    label: '计数',
    value: 'COUNT',
  },
  {
    label: '计数去重',
    value: 'COUNT_DISTINCT',
  },
];

export const AGGREGATION_SETTERS: Setter[] = [
  {
    title: '聚合方式',
    name: AggregationType.Metrics,
    display: 'inline',
    defaultValue: null,
    setter: {
      componentName: 'CnSelectSetter',
      props: {
        options: AGGREGATION_METRICS_OPTIONS,
      },
    },
  },
];
